import makeStyles from '@material-ui/styles/makeStyles';

const style = makeStyles(() => ({
    tabsSection: {
        '& .MuiAppBar-colorPrimary': {
            backgroundColor: 'inherit',
            boxShadow: 'none',
            '& .MuiButtonBase-root': {
                border: 'solid 1px #53252f',
                color: '#53252f',
                background: 'none',
                borderRadius: 30,
                minHeight: 32,
                lineHeight: '18px',
                textTransform: 'capitalize',
                minWidth: 'inherit',
                marginRight: 10,
            }
        }
    },
    topIconImage: {
        marginTop: 'auto 5px',
        position: 'absolute !important',
        left: '90%',
        bottom: '90%',
        transform: 'translate(-50%, -50%)',
        fill: 'white',
        cursor: 'pointer',
    }
}));

export default style;
